import {styled} from "@mui/material";
import { getResponsiveCSS } from '@utils/cssHelpers';

export const PLACEMENT = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const StyledLabel = styled('label')({
  display: 'block',
  marginBottom: 8,
});

export const InputContainer = styled('span')({
  width: '100%',
  position: 'relative',
  display: 'inline-block',
  marginBottom: 5,
});

export const IconContainer = styled('div')(
  {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ({ placement }) => ({
    [placement === PLACEMENT.LEFT ? 'left' : 'right']: 0,
  })
);

export const PasswordVisibilityButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 40,
  height: '100%',
  padding: 0,
  border: 0,
  background: 'transparent',
  color: theme.palette.novotalk.$textColorDarkBlue,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 20,
}));

export const StyledInput = styled('input')(
  {
    width: '100%',
    padding: '0px 15px',
    boxSizing: 'border-box',
    borderRadius: 3,
    fontSize: 14,
    letterSpacing: '-0.2px',
  },
  getResponsiveCSS('height', 44, 48),
  ({ theme, error, iconPlacement, showPasswordToggle }) => ({
    paddingLeft: iconPlacement === PLACEMENT.LEFT ? 40 : 15,
    paddingRight: iconPlacement === PLACEMENT.RIGHT || showPasswordToggle ? 40 : 15,
    color: theme.palette.novotalk.$textColorDarkBlue,
    border: `1px solid ${error ? theme.palette.novotalk.$errorColor : theme.palette.novotalk.$inputBorderColor}`,
    backgroundColor: theme.palette.novotalk.$backgroundColor,
    '&:focus': {
      border: `1px solid ${theme.palette.novotalk.$inputBorderColorActive}`,
    },
    '&::placeholder': {
      color: theme.palette.novotalk.$textColorDisabled,
    },
    '&:disabled': {
      backgroundColor: theme.palette.novotalk.$inputBackgroundColorDisabled,
      color: theme.palette.novotalk.$textColorDisabled,
      cursor: 'not-allowed',
    },
  })
);
